<template>
  <div class="transfer-terms">
    <div class="patient-content">
      <p>
        Você precisa aceitar o termo de responsabilidade para <a href="#">{{ patients.length }} dos pacientes</a> que serão transferidos:
      </p>
      
      <ol :class="expansionPatientList">
        <li
          v-for="(patient, i) in patients"
          :key="i"
        >
          {{ patient.name }}
        </li>
      </ol>
      <div
        v-if="patients.length > 2"
        class="toggle-list"
      >
        <button
          :class="togglePatientList ? 'closed': 'open'"
          @click="openList"
        >
          <span>Ver todos</span>
          <md-icon>arrow_drop_down</md-icon>
        </button>
      </div>
    </div>

    <ul class="docs-download">
      <li>
        <a
          href="https://storageapoiob2bprd.blob.core.windows.net/aol-downloads/REQ01064-%20DETERMNACAO%20SEXO%20FETAL-%20QUESTIONARIO.pdf"
          target="_blank"
          class="btn"
        >
          <md-icon
            class="icon-download-doc"
            md-src="/static/images/icon-doc-details.svg"
          />
          REQ01064-Determinacao do Sexo Fetal
        </a>
      </li>
    </ul>

    <div class="info-term">
      <p>
        Declaro, para todos os fins, que informei ao meu paciente/cliente final claramente a respeito da porcentagem de acerto de 99% para este exame. Declaro ainda, que mantenho sob minha posse e responsabilidade o termo “REQ01064-Determinacao do Sexo Fetal” preenchido e assinado pelo paciente/cliente final.
      </p>
    </div>

    <md-layout
      md-flex="40"
      md-flex-medium="40"
      class="inputidlab"
    >
      <md-input-container
        id="adminIDLab"
        :class="{'md-input-invalid': errors.has('idlab')}"
      >
        <label>Nome completo do responsável</label>
        <md-input
          v-model="patient.nome"
          data-vv-validate-on="none"
          maxlength="250"
          type="text"
          placeholder="Nome completo do responsável pela coleta do formulário"
        />
        <md-icon
          class="icon-user"
          md-src="/static/images/user-login.svg"
        />
      </md-input-container>
    </md-layout>

    <md-layout
      md-flex="20"
      md-flex-medium="20"
    >
      <md-input-container
        id="adminIDLab"
        :class="{'md-input-invalid': errors.has('idlab')}"
      >
        <label>CPF do responsável</label>
        <md-input
          v-model="patient.cpf"
          v-mask="'###.###.###-##'"
          v-validate="'required'"
          data-vv-validate-on="none"
          type="text"
          placeholder="CPF do responsável pela coleta do formulário"
        />
        <md-icon
          class="icon-id"
          md-src="/static/images/icon-id.svg"
        />
      </md-input-container>
    </md-layout>

    <div class="actions">
      <md-button
        class="btn btn-nonenary"
        @click="closeModal"
      >
        Cancelar
      </md-button>
      <md-button
        class="btn btn-primary"
        :disabled="isFieldsEmpty"
        @click="openTransfer"
      >
        Aceitar termo e transferir
        <md-icon
          class="icon-check"
          md-src="/static/images/icon-check-thin.svg"
        />
      </md-button>
    </div>
  </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import { mapGetters } from 'vuex'
import consentService from '@/api/consent'
import documentManagementService from '@/api/documentManagement'
import notify from '@/api/notification'
import { convertBase64ToFile } from '@/utils/convertBase64ToFile'

import {
  ORDER_STATE_RECEIVED,
  ORDER_STATE_VALIDATED,
  ORDER_STATUS_ERROR
} from '@/enums'

export default {
  name: 'TransferTermsModal',
  directives: {
    'mask': mask
  },
  props: {
    orderSelected: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    selected: [],
    togglePatientList: false,
    osData: [],
    patient: {
      nome: '',
      cpf: ''
    }
  }),
  computed: {
    ...mapGetters([
      'orders'
    ]),
    ordersId () {
      if (!this.orderSelected.length) {
        return this.orders.map(order => order.id)
      }
      return this.orders.filter(order => this.orderSelected.includes(order.id)).map(order => order.id)
    },
    documentsRequired () {
      if (!this.orderSelected.length) {
        return this.orders
          .filter(this.orderCanBeTransmitted)
          .map(order => order.exams)
          .flat()
          .filter(exam => exam.exam_sent === 'SEXA')
          .map(exam => exam.documentExamsRequired || [])
          .flat()
          .filter((order, index) => index === 0)
      }
      return this.orders
        .filter(order => this.orderSelected.includes(order.id))
        .map(order => order.exams)
        .flat()
        .filter(exam => exam.exam_sent === 'SEXA')
        .map(exam => exam.documentExamsRequired || [])
        .flat()
        .filter((order, index) => index === 0)
    },
    patients () {
      if (!this.orderSelected.length) {
        return this.orders
          .filter(this.orderCanBeTransmitted)
          .filter(order => order.exams.some(exam => exam.exam_sent === 'SEXA'))
          .map(order => ({
            name: order.patient.name,
            id: order.id
          }))
      }
      return this.orders
        .filter(order => this.orderSelected.includes(order.id))
        .filter(order => order.exams.some(exam => exam.exam_sent === 'SEXA'))
        .map(order => ({
          name: order.patient.name,
          id: order.id
        }))
    },
    isFieldsEmpty () {
      return this.patient.nome === '' || this.patient.cpf.length !== 14
    },
    expansionPatientList () {
      return this.togglePatientList ? 'patient-list open' : 'patient-list'
    }
  },
  methods: {
    closeModal () {
      this.patient.nome = ''
      this.patient.cpf = ''
      this.$emit('closeModal')
    },
    setOrder () {
      const data = this.orders
        .filter(order => this.ordersId.includes(order.id))
        .map(order => order.exams.map(exam => ({ idExamOrder: exam.id, osNumber: order.id })))
        .flat()
      this.osData = data
    },
    async openTransfer () {
      try {
        this.setOrder()
        const patientData =  { nome: this.patient.nome, cpf: this.patient.cpf.match(/\d/g).join('') }
        await consentService.accept(patientData, this.osData)
        this.$store.commit('OS_CONSENT_FORM', patientData)
        this.$store.commit('OS_EXAM_NUMBER', this.osData)
        this.$emit('transferOs', this.ordersId)
      } catch (error) {
        console.log(error)
        this.closeModal()
      }
    },
    openList () {
      this.togglePatientList = !this.togglePatientList
    },
    documentDownload () {
      documentManagementService
        .downloadDocumentByUuid(this.documentsRequired[0].documentTemplateUuid)
        .then(response => {
          let fileName = this.documentsRequired[0].fileName
          let fileExtension = fileName.split('.')[1]
          convertBase64ToFile({
            file: response,
            fileName: fileName,
            fileExtension: fileExtension
          })
          notify({
            title: 'AVISO:',
            message: 'Download realizado com sucesso.'
          })
        })
        .catch(() => {
          notify({
            title: 'AVISO:',
            message: 'Não foi possível visualizar o documento.'
          })
        })
    },
    orderCanBeTransmitted (order) {
      let orderIncorrectReceived = order.state !== ORDER_STATE_RECEIVED
      let orderIncorrectStatus = order.status !== ORDER_STATUS_ERROR
      let orderInValidatedState = order.state === ORDER_STATE_VALIDATED
      return (
        orderInValidatedState &&
        orderIncorrectStatus &&
        orderIncorrectReceived
      )
    }
  }
}
</script>

<style lang="scss">
  .transfer-terms {
    .md-input-container {
      margin-bottom: 10px;
      font-family: 'Roboto', sans-serif;
      input {
        &::placeholder {
          font-size: 14px;
        }
      }
    }
    .info-term {
      margin-bottom: 10px;
      p {
        color: #5A5A5A;
        font-size: 13px;
      }
    }
    .docs-download {
      margin: 15px 0;
      .btn {
        cursor: pointer;
        font-weight: normal;
        color: #5A5A5A;
        display: inline-block;
        background-color: #F2F2F2;
        border-radius: 4px;
        line-height: 25px;
        padding: 6px 10px;
        height: 38px;
        width: 100%;
        text-align: initial;
        text-decoration: underline;
        font-family: 'Exo 2', sans-serif;
      }
    }
    .patient-content {
      margin: 10px 0;
      p {
        margin: 10px 0;
        color: #5A5A5A;
        a {
          color: #7F1A54 !important;
          font-weight: 600;
        }
      }
      ol.patient-list {
        height: 50px;
        overflow: hidden;
        transition: all 200ms ease-in;
        li {
          background-color: #F2F2F2;
          list-style: inside;
          padding: 1px 8px;
          margin: 3px 0;
          color: #5A5A5A;
        }
        &.open {
          height: auto;
          max-height: 128px;
          overflow-y: scroll;
          padding-right: 3px;
          &:hover {
            &::-webkit-scrollbar-track {
              background: #F2F2F2;
              border-radius: 60px;
            }
          }
          &::-webkit-scrollbar {  
            width: 4px;
            padding-left: 3px;
            right: -10px;
          }
          &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 60px;
          }
        }
      }
      .toggle-list {
        text-align: center;
        margin-top: 8px;
        &:hover {
          span {
            text-decoration: underline;
            color: #7F1A54;
          }
          i {
            color: #7F1A54;
          }
        }
        button {
          cursor: pointer;
          background: transparent;
          padding: 0;
          color: #5A5A5A;
          font-family: 'Exo 2', sans-serif;
          font-weight: normal;
          height: auto;
          i {
            color: #5a5a5a;
            font-size: 21px;
            margin-top: -2px;
          }
          &.closed {
            i {
              transform: rotate(-180deg);
            }
          }
        }
      }
    }
    .actions {
      margin-top: 20px;
      display: flex;
      justify-content: space-between;
      .btn-primary,
      .btn-nonenary {
        padding: 0 25px;
        height: 40px;
        &:disabled {
          color: #fff;
        }
      }
    }
    .icon-check {
      min-width: 18px;
      width: 18px;
      margin-left: 10px;
      margin-top: -3px;
    }
    .icon-user,
    .icon-id {
      min-width: 20px;
      width: 20px;
      path, line {
        fill: #9D9D9D;
      }
    }
    .icon-download-doc {
      width: 20px;
      margin-right: 5px;
      margin-top: -5px;
      svg {
        width: 20px;
      }
    }
  }
</style>
